module.exports = __webpack_public_path__ + "bed-quilt2-slogan.1b4eed4e.png";